export default __webpack_public_path__ + "static/media/trash.23f387f1.svg";